<template>
    
    <main id="page">

        <h1>404</h1>
    </main>
</template>

<script>

export default {
    
    mounted () {
        this.$emit('loaded') // Tell App data is ready
    },
    data () {
        return {}
    },
    components: {},
}
</script>

<style lang="scss" scoped>

@import '../scss/variables';

#page {
    @include page-padding;

    article {
        position: relative;
        padding: 188px;
        
        p {
            margin-bottom: $spacing-large;
            font-size: 38px;
            
            &.no-spacing {
                margin-bottom: 0px;
            }
            
            &.small {
                font-size: 15px;
                max-width: 640px;
            }
        }
    }
    
    .social {
        margin: 0 auto;
        width: 25%;
        min-width: 420px;
        text-align: center;
        padding-bottom: $spacing-large;
        
        p {
           font-size: 15px; 
        }
        .links {
            a {
                vertical-align: top;
                display: inline-block;
                color: $color-text-prime;
            }
        }
    }
}
</style>
